import type { ReactNode, CSSProperties, JSX } from 'react';
import { modalClasses } from '../modal.classes';
import Box from '@mui/material/Box';

type Props = {
  children: ReactNode;
  styles?: CSSProperties;
};

/**
 * The main content area of the Modal. Typically has `<ModalBody>`, `<ModalHeader>` and `<ModalFooter>` as children. Has to be placed within `<Modal>`.
 */
export const ModalContent = ({ styles, children }: Props): JSX.Element => (
  <Box
    className={modalClasses.content}
    style={styles}
    sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      justifyContent: 'flex-start',
      width: '100%',
      height: '100%',
      overflow: 'hidden',
    }}
  >
    {children}
  </Box>
);
